<template>
  <div class="slider-container" v-touch:swipe="swipeCarousel()">
    <div class="arrow arrow--left" @click="nextImage(initialImage, labelImageToShow)"></div>
    <div class="photo_slider">
      <img
        :src="
          require(`@/assets/images/${labelImageToShow}/${initialImage}.jpg`)
        "
        alt
        class="resize-image"
      />
      <figcaption>{{ $t(`label.${labelImageToShow}.photos.${initialImage}`) }}</figcaption>
    </div>
    <div class="arrow arrow--right" @click="backImage(initialImage, labelImageToShow)"></div>
  </div>
</template>

<script>
export default {
  name: "Slider",

  props: ["photosNumber", "labelImageToShow"],

  data: function() {
    return {
      initialImage: this.photosNumber
    };
  },

  methods: {
    backImage: function(imageSelected, labelImageToShow) {
      imageSelected -= 1;

      const imageNext =
        this.$t(`label.${labelImageToShow}.photos.${imageSelected}`) === "---"
          ? 1
          : 0;

      this.initialImage =
        imageSelected === 0 ? this.photosNumber : (imageSelected -= imageNext);
    },

    nextImage: function(imageSelected, labelImageToShow) {
      imageSelected += 1;

      const imageNext =
        this.$t(`label.${labelImageToShow}.photos.${imageSelected}`) === "---"
          ? 1
          : 0;

      this.initialImage =
        imageSelected > Number(this.photosNumber)
          ? 1
          : (imageSelected += imageNext);
    },

    swipeCarousel() {
      const superThis = this;
      return function(direction) {
        if (direction === "left") {
          return superThis.backImage(superThis.initialImage);
        }

        return superThis.nextImage(superThis.initialImage);
      };
    }
  }
};
</script>

<style>
.slider-container {
  position: relative;
}
.photo_slider {
  position: relative;
  height: 450px;
  padding-top: 70px;
}

figcaption {
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
}

.resize-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.arrow {
  color: rgb(0, 0, 0);
  align-items: flex-start;
  text-transform: uppercase;
  position: relative;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.arrow:before {
  content: "";
  display: block;
  border: solid rgb(0, 0, 0);
  border-width: 2px 2px 0 0;
  width: 10px;
  height: 10px;
}
.arrow--right {
  position: absolute;
  left: 100%;
  top: 50%;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.arrow--left {
  position: absolute;
  top: 50%;
  right: 100%;
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}

@media (max-width: 833px) {
  .photo_slider {
    height: 250px;
    padding-top: 77px;
  }
}
</style>
